import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import logoImage from "../../assets/images/logo.png";
import { userLoggedOut } from "../../features/auth/authSlice";
import gravatarUrl from "gravatar-url";

export default function Navigation() {
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.auth);
    const { email, name } = user || {};

    const logout = () => {
        dispatch(userLoggedOut());
        localStorage.clear();
    };
    return (
        <nav className="border-general sticky top-0 z-40 border-b bg-slate-700 transition-colors">
            <div className="max-w-7xl mx-auto">
                <div className="flex justify-between h-16 items-center mx-4">
                    <Link to="/">
                        <img
                            className="h-10"
                            src={logoImage}
                            alt="Learn with Sumit"
                        />
                    </Link>
                    <ul className="flex justify-center align-center">
                        <li className="mr-2">
                            <img
                                className="object-cover w-7 h-7 rounded-full"
                                src={gravatarUrl(email, {
                                    size: 80,
                                })}
                                alt={name}
                            />
                        </li>
                        <li className="text-white mr-4">
                            <span>{name}</span>
                        </li>
                        <li className="text-white">
                            <span className="cursor-pointer" onClick={logout}>
                                Logout
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}
